import { useQuestionStore } from "@/stores/question-store";
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";

export function InputImage() {
  const selectedQuestionId = useQuestionStore((s) => s.selectedQuestionId);
  const questions = useQuestionStore((s) => s.questions);
  const updateQuestion = useQuestionStore((s) => s.updateQuestion);

  const selectedQuestion = questions.find(
    (q) => q.question.id === selectedQuestionId
  );

  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    if (selectedQuestion && selectedQuestion.imageUploadURL) {
      setImage(selectedQuestion.imageUploadURL);
    }
  }, [selectedQuestion]);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const url = URL.createObjectURL(file);
      setImage(url);
    }
  };

  useEffect(() => {
    if (selectedQuestion && image) {
      updateQuestion({
        ...selectedQuestion,
        imageUploadURL: image,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image, selectedQuestion]);

  if (!selectedQuestion) return null;

  return (
    <div className="bg-[#37393F] flex items-center justify-center rounded-lg cursor-pointer h-56 relative">
      <input
        type="file"
        accept=".jpg, .png"
        onChange={handleImageChange}
        className="absolute inset-0 m-4 opacity-0 cursor-pointer"
      />
      {image ? (
        <img
          src={image}
          alt="Question image"
          className="w-full h-full object-cover rounded-lg"
        />
      ) : (
        <>
          <Add /> Question image
        </>
      )}
    </div>
  );
}
